import React from 'react';
import { LearningPathBlockPlayer } from './block-player';
import { DialogContent, DialogTitle } from '@/components/ui/dialog';
import { LearningBlockPlayer } from '@/components/custom/learning-block';
import { isVimeoUrl } from '@/lib/utils';

export function LearningPathBlockVideoModal(props) {
  const { video } = props;

  return (
    <DialogContent size="md">
      <DialogTitle className="sr-only">Assista o vídeo</DialogTitle>

      <LearningBlockPlayer>
        {isVimeoUrl(video['video-url']) && (
          <LearningPathBlockPlayer
            key={video['video-url']}
            videoId={video['video-url']}
          />
        )}
      </LearningBlockPlayer>
    </DialogContent>
  );
}
